import type { IconSvgObject } from './types';

const Presentation04Icon: IconSvgObject = [
  ["path", { d: "M21.5 14.5V6.5C21.5 4.84315 20.1569 3.5 18.5 3.5H5.5C3.84315 3.5 2.5 4.84315 2.5 6.5V14.5C2.5 16.1569 3.84315 17.5 5.5 17.5L18.5 17.5C20.1569 17.5 21.5 16.1569 21.5 14.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 18L12 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 2L12 3.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 22L12.0001 19L17 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Presentation04Icon;
